import Axios from 'axios'
import React, { FormEvent, useEffect, useState } from 'react'
import { FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { DriverFio } from '../drivers/driverFio'

export const EditAdvance: FunctionComponent = () => {
  const [disabled, setDisabled] = useState(false)
  const [date, setDate] = useState('')
  const [amount, setAmount] = useState(0)
  const [comment, setComment] = useState('')

  const { driverId } = useParams<{ driverId: string }>()
  const { advanceId } = useParams<{ advanceId: string }>()

  useEffect(() => {
    const loadAdvance = async () => {
      setDisabled(true)

      try {
        const fine = await Axios.get<{
          date: string
          amount: number
          carNumber: string
          carId: string
          comment: string
        }>(
          `${process.env.REACT_APP_API_URL}/api/v1/advances/${driverId}/${advanceId}`
        )
        setDate(fine.data.date.replace('T00:00:00', ''))
        setAmount(fine.data.amount)
        setComment(fine.data.comment)
      } finally {
        setDisabled(false)
      }
    }

    loadAdvance()
  }, [driverId, advanceId])

  const editAdvance = async (_: FormEvent) => {
    _.preventDefault()

    setDisabled(true)

    try {
      await Axios.put(
        `${process.env.REACT_APP_API_URL}/api/v1/advances/${advanceId}`,
        {
          date,
          amount,
          comment,
        }
      )

      toast.success('Аванс обновлён.')
    } finally {
      setDisabled(false)
    }
  }

  return (
    <div className="row">
      <div className="col">
        <form onSubmit={editAdvance}>
          <fieldset disabled={disabled}>
            <div className="form-group">
              <label>
                <DriverFio driverId={driverId} />
              </label>
            </div>
            <div className="form-group">
              <label>Дата</label>
              <input
                className="form-control"
                required
                type="date"
                value={date.toString().replace('+00:00', '')}
                onChange={(_) => setDate(_.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Сумма</label>
              <input
                className="form-control"
                required
                type="number"
                value={amount}
                min={0.01}
                step={0.01}
                onChange={(_) => setAmount(parseFloat(_.target.value))}
              />
            </div>
            <div className="form-group">
              <label>Комментарий</label>
              <textarea
                className="form-control"
                rows={5}
                value={comment}
                onChange={(_) => setComment(_.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-success">
              <i className="fas fa-save"></i> Сохранить
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  )
}
